
import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js'; 
import DashboardService from '../../../services/dashboard-service.js';

const ViewCommssion = () => { 
  const [transaction, setTransaction] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const naviagate = useNavigate()
  const [role,setUserRole] = useState('');
  const userData = useSelector(state => state.authReducer);

  const getTransaction = () => {
    setLoading(true);
    DashboardService.getCommissionDetails(id)
          .then(response => {
            const data =response.data.data
            setTransaction(data)
            setLoading(false);
          })
          .catch(error => {
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
  }
useEffect(() => {
  if(userData && userData.user && userData.user.data) {
    const userRole = userData.user.data.role.role_code
    console.log(userRole)
    setUserRole(userRole)
  }
  getTransaction();
  document.body.style.backgroundImage = '';

    document.body.style.backgroundColor = '#f0f6fa';
    return () => {
      document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
}, []);

const back = () => {
  naviagate(-1); 
}
const viewLifeCycle = () => {
  naviagate(`/view-lifecycle/${id}`)
}



    return(
      <><LoaderOverlay loading={loading}/>
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Commission Details</h4>
        <div className="row ghty" style={{backgroundColor: 'white', height: 'auto', paddingBottom: '20px'}}>
          <ul className="nav nav-tabs">
            <li className="nav-item tbbtrn">
              <a className="nav-link active_tab1" id="list_per_details">Commission Information</a>
            </li>
          </ul>
          <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
            <div className="tab-pane active" id="per_details">
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">ORDER ID</label>
                        <p>{transaction.order_code}</p>
                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">UTR</label>
                        <p>{transaction.utr_id || '-'}</p>
                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">PAYMENT TYPE</label>
                        {/* <p style={{color: 'red'}}><i className="fa fa-money me-1" style={{color: 'red'}} /> Payin</p> */}

                        <p style={{ color: transaction && transaction.transaction_type?.toLowerCase() === 'payin' ? 'green' : 'red' }}><i className="fa fa-money me-1" style={{ color: transaction && transaction.transaction_type?.toLowerCase() === 'payin' ? 'green' : 'red' }} />  {transaction && transaction.transaction_type ? transaction.transaction_type.charAt(0).toUpperCase() + transaction.transaction_type.slice(1).toLowerCase() : ''}</p>

                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">TOTAL</label>
                        <p>₹{transaction.transaction_amount}</p>
                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">PAYMENT METHOD</label>
                        <p><i className={`fa  me-1 ${
                           transaction.payment_method && transaction.payment_method?.toLowerCase() === 'imps' ? 'fa-money' :
                           transaction.payment_method && transaction.payment_method?.toLowerCase() === 'wallet' ? 'fa-credit-card' :
                           transaction.payment_method && transaction.payment_method?.toLowerCase() === 'upi' ? 'fa-google-wallet' :
                           transaction.payment_method && transaction.payment_method?.toLowerCase() === 'qr' ? 'fa-qrcode ' :
                            ''}`} /> {transaction.payment_method || '-'} </p>
                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">SUB PAYMENT METHOD</label>
                        <p>{transaction.payment_method_type || '-'}</p>
                      </div>
                    </div>
{transaction.vpa && (
 <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
 <div className="form-group frm" style={{textAlign: 'left'}}>
   <label htmlFor="f_name">VPA</label>
   <p style={{wordWrap:'break-word'}}>{transaction.vpa || '-'}</p>
 </div>
</div>
)}
                   
                   {transaction.bank_account && (
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Bank Account</label>
                        <p>{transaction.bank_account || '-'}</p>
                      </div>
                    </div>
                    )}
  {transaction.mobile && (
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Mobile</label>
                        <p>{transaction.mobile || '-'}</p>
                      </div>
                    </div>
                     )}

{transaction.ifsc && (
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">IFSC</label>
                        <p>{transaction.ifsc || '-'}</p>
                      </div>
                    </div>
                     )}

                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">DATE</label>
                        <p>{transaction.start_date}</p>
                      </div>
                    </div>
     {role !='ADMIN' && (
          <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
          <div className="form-group frm" style={{textAlign: 'left'}}>
            <label htmlFor="f_name">COMMSSION AMOUNT</label>
            <p>{ role === 'DADMIN' ? `₹${transaction.distributor_commission}` :
            role === 'AGENT' ? `₹${transaction.agent_commission}` :
            `₹${transaction.merchant_commission}` }</p>
          </div>
        </div>
     )}
       {role =='ADMIN' && (
        <>
          <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
          <div className="form-group frm" style={{textAlign: 'left'}}>
            <label htmlFor="f_name">AGENT COMMSSION</label>
            <p>₹{transaction.agent_commission || 0}</p>
          </div>
        </div>
        <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
        <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="f_name">MERCHANT COMMSSION</label>
          <p>₹{transaction.merchant_commission || 0}</p>
        </div>
      </div>
      <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
        <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="f_name">Agent Name</label>
          <p>{transaction.agent_name || '-'}</p>
        </div>
      </div>
      <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
        <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="f_name">Merchant Name</label>
          <p>{transaction.merchant_name || '-'}</p>
        </div>
      </div>
      <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
        <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="f_name">Distributor Code</label>
          <p>{transaction.distributor_code || 0}</p>
        </div>
      </div>
      <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
        <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="f_name">Distributor Commission</label>
          <p>₹{transaction.distributor_commission || 0}</p>
        </div>
      </div>
 
      </>
     )}
      <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
        <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="f_name">Agent Code</label>
          <p>{transaction.agent_code || '-'}</p>
        </div>
      </div>
                
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">UPDATED ON</label>
                        <p>{transaction.updated_date}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a style={{width: 'auto', padding: '0px'}} onClick={back}><button className="btn btn-bg-theme-Color backbt">Back</button></a>
            {/* <a style={{width: 'auto', padding: '0px', paddingLeft: '10px'}}  onClick={viewLifeCycle}><button className="btn btn-success raisbt vtl">Track Transaction</button></a>
             */}
          </div>
        </div>
      </div>
      </>
    )

}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(ViewCommssion));